import { api } from "@/lib/api";
import { triggerDownload } from "@/lib/download";
import { toast } from "sonner";

// As empresas da folha vêm prontas da API (resumo do GET /beneficios/folhas/:id).
export type { EmpresaDaFolha } from "@/data/beneficios";

/** O que baixar: todas as empresas numa planilha, só uma empresa, ou um .zip com uma por empresa. */
export type AlvoExportacao = { tipo: "todas" } | { tipo: "empresa"; cnpj: string } | { tipo: "zip" };

const caminho = (id: string, alvo: AlvoExportacao) =>
  alvo.tipo === "zip"
    ? `/beneficios/folhas/${id}/exportar-zip`
    : alvo.tipo === "empresa"
      ? `/beneficios/folhas/${id}/exportar?cnpj=${alvo.cnpj}`
      : `/beneficios/folhas/${id}/exportar`;

/** Baixa a planilha de pedido da Flash. Devolve false se a API recusou (ex.: cadastro sem CPF). */
export async function exportarFolhaBeneficio(id: string, alvo: AlvoExportacao = { tipo: "todas" }): Promise<boolean> {
  try {
    const { blob, filename } = await api.getFile(caminho(id, alvo));
    triggerDownload(blob, filename);
    return true;
  } catch (err) {
    toast.error(err instanceof Error ? err.message : "Erro ao exportar", { duration: 10000 });
    return false;
  }
}
